var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dp-checkbox",class:_vm.disabled ? 'disabled' : 'clickable',on:{"click":function($event){!_vm.disabled && _vm.click()}}},[(_vm.value)?_c('div',{staticClass:"checked"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }